<template>
    <div class="c-app">
        <div class="container">
            <div id="btn-open-caja" class="d-flex justify-content-end pt-2 mt-2">
                <div class="btn-group btn-home" role="group">
                    <button type="button" class="btn btn-outline-main bg-main text-white" @click="mtdBackCampus">
                        <i class="fas fa-recycle"></i> Cambiar de Sede
                    </button>
                </div>
            </div>
            <div class="row px-3" id="div_conte2">
                <div id="div_conte" class="col-md-10 mx-auto">
                    <div class="bg-secondary text-white bg-opacity-10">
                        <div class="text-center py-3 px-5 btn-home" id="scroll-div">
                            <div class="row mt-2">
                                <button class="div-campus col m-2 p-2 text-white" @click="changePage('oc')">
                                    ORDEN DE COMPRA
                                </button>
                                <button class="div-campus col m-2 p-2 text-white" @click="changePage('servicios')">
                                    ORDEN DE SERVICIOS
                                </button>
                                <button class="div-campus col m-2 p-2 text-white" @click="changePage('factura')">
                                    REPORTE DE FACTURA
                                </button>
                                <button class="div-campus col m-2 p-2 text-white" @click="changePage('compra')">
                                    COMPRAS
                                </button>
                                <button class="div-campus col m-2 p-2 text-white" @click="changePage('notaIngreso')">
                                    NOTA DE INGRESO
                                </button>

                            </div>
                            <div class=" row">

                                <button class="div-campus col m-2 p-2 text-white" @click="changePage('inventario')">
                                    INVENTARIO
                                </button>
                                <button class="div-campus col m-2 p-2 text-white" @click="changePage('mantenimiento')">
                                    MANTENIMIENTO
                                </button>
                                <button class="div-campus col m-2 p-2 text-white" @click="changePage('cxp')">
                                    CXP
                                </button>
                                <button class="div-campus col m-2 p-2 text-white" @click="changePage('sire')">
                                    SIRE
                                </button>
                                <button class="div-campus col m-2 p-2 text-white" @click="changePage('ubicacion')">
                                    UBICACION
                                </button>

                                <!-- <button class="div-campus col m-2 p-2 text-white" @click="changePage('stock')">
                                STOCK
                            </button>  -->
                                <!-- <button class="div-campus col m-2 p-2 text-white" @click="changePage('verificacion')">
                               VERIFICACION STOCK
                            </button> -->
                            </div>
                            <div class=" row">
                                <button class="div-campus col m-2 p-2 text-white" @click="changePage('new_report')">
                                    SEGUIMIENTO DE MEDICAMENTOS
                                </button>
                                <button class="div-campus col m-2 p-2 text-white" @click="changePage('new_purchase')">
                                    REGISTRAR COMPRAS
                                </button>
                                <button class="div-campus col m-2 p-2 text-white" @click="changePage('stock_stats')">
                                    ESTADÍSTICAS DE STOCK
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: 'homeLogistics',
    data() {
        return {
            page: null
        }
    },
    methods: {
        changePage(page) {
            this.$emit('mtdChangePage', page)
        },
        mtdBackCampus: function () {
            this.$emit('mtdBackCampus')
        },
    }
}
</script>
<style scoped>
@media (max-width: 415px) {
    #scroll-div {
        height: 140px;
    }
}

@media (max-width: 1024px) {
    #scroll-div {
        /*height: 200px;*/
        height: 550px;
    }
}

@media (max-width: 768px) {
    #scroll-div {
        /*height: 170px;*/
        height: 500px;
    }
}
</style>